export function initializeMetaAPI(_unpatchedConsole, internalLogger, _config, metas, _transports) {
    internalLogger.debug('Initializing meta API');
    let metaSession = undefined;
    let metaUser = undefined;
    let metaView = undefined;
    const setUser = (user) => {
        if (metaUser) {
            metas.remove(metaUser);
        }
        metaUser = {
            user,
        };
        metas.add(metaUser);
    };
    const setSession = (session) => {
        if (metaSession) {
            metas.remove(metaSession);
        }
        metaSession = {
            session,
        };
        metas.add(metaSession);
    };
    const getSession = () => metas.value.session;
    const setView = (view) => {
        if (metaView) {
            metas.remove(metaView);
        }
        metaView = {
            view,
        };
        metas.add(metaView);
    };
    const getView = () => metas.value.view;
    return {
        setUser,
        resetUser: setUser,
        setSession,
        resetSession: setSession,
        getSession,
        setView,
        getView,
    };
}
//# sourceMappingURL=initialize.js.map